(() => {
  let mapping;
  const escapePattern = value => value.replace(/[.*+?^$\{\}()|[\]\\]/g, '\\$&');
  async function enhance(root = document) {
    const note = document.querySelector('[data-jacu-garment-feel]');
    const destination = document.querySelector('[data-jacu-fabric-links]');
    if (note && destination && !document.querySelector('.jacu-garment-feel')) {
      destination.before(note.content.cloneNode(true));
    }
    const mounts = root.querySelectorAll('[data-jacu-fabric-links]:not([data-enhanced])');
    if (!mounts.length) return;
    try {
      mapping ||= fetch(mounts[0].dataset.mapUrl).then(response => {
        if (!response.ok) throw new Error('Fabric map unavailable');
        return response.json();
      }).catch(error => { mapping = undefined; throw error; });
      const map = await mapping;
      const aliases = map.flatMap(item => item.aliases.map(alias => ({ alias, item })))
        .sort((a, b) => b.alias.length - a.alias.length);
      const pattern = new RegExp('\\b(?:' + aliases.map(({ alias }) => escapePattern(alias)).join('|') + ')\\b', 'gi');
      mounts.forEach(mount => {
        if (mount.dataset.enhanced) return;
        const details = mount.closest('.jp-details') || mount.parentElement;
        const description = details.querySelector('.rte, .product__description');
        if (!description) return;
        const lines = [...description.querySelectorAll('li, p, tr')].filter(element => {
          const text = element.textContent;
          return /(?:composition|materials?|fabric)\s*:/i.test(text) ||
            /\d+(?:[.,]\d+)?\s*%/.test(text);
        });
        const composition = lines.map(element => element.textContent).join(' ');
        const matches = [...composition.matchAll(pattern)].map(match =>
          aliases.find(entry => entry.alias.toLowerCase() === match[0].toLowerCase()).item
        );
        const unique = [...new Map(matches.map(item => [item.label, item])).values()];
        if (unique.length) {
          const guide = mount.querySelector('.jacu-fabric-guide');
          guide.href = mount.dataset.destination + '#' + unique[0].anchor;
          unique.forEach(item => {
            const link = document.createElement('a');
            link.href = mount.dataset.destination + '#' + item.anchor;
            link.textContent = item.label;
            mount.append(link);
          });
        }
        mount.dataset.enhanced = 'true';
      });
    } catch {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance());
  else enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
